import { Card } from "@rumbledirect/ui";
import { List } from "antd";
import { formatDistanceToNow } from "date-fns";
import { nl } from "date-fns/locale";
import { Typography } from "antd";
import { AgentSession } from "@rumble-it/common-lib/types/models/AgentSession.interface";

const { Text } = Typography;

interface AgentDossierSessionsCardProps {
  isLoading: boolean;
  sessions: AgentSession[];
  selectedSession: AgentSession | null;
  setSelectedSession: (session: AgentSession | null) => void;
}

export const AgentDossierSessionsCard = ({
  isLoading,
  sessions,
  selectedSession,
  setSelectedSession,
}: AgentDossierSessionsCardProps) => {
  return (
    <Card
      loading={isLoading}
      title="Chat sessies"
      style={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <List
        dataSource={sessions}
        renderItem={(session) => (
          <List.Item
            onClick={() => setSelectedSession(session)}
            style={{
              cursor: "pointer",
              backgroundColor:
                selectedSession?.id === session.id ? "#f0f0f0" : "transparent",
              padding: "12px",
              borderRadius: "4px",
              marginBottom: "8px",
            }}
          >
            <List.Item.Meta
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Text strong>{session.id}</Text>
                </div>
              }
              description={
                <div>
                  <div>
                    <Text type="secondary" style={{ fontSize: "12px" }}>
                      Aangemaakt:{" "}
                      {formatDistanceToNow(new Date(session.createdAt), {
                        addSuffix: true,
                        locale: nl,
                      })}
                    </Text>
                  </div>
                  <div>
                    <Text type="secondary" style={{ fontSize: "12px" }}>
                      Laatst gewijzigd:{" "}
                      {formatDistanceToNow(new Date(session.updatedAt), {
                        addSuffix: true,
                        locale: nl,
                      })}
                    </Text>
                  </div>
                </div>
              }
            />
          </List.Item>
        )}
      />
    </Card>
  );
};
